import { lumi } from '@/lib/lumi'
import type { NewsBanner } from '@/types/radio'
import { useCallback, useEffect, useState } from 'react'

export function useNewsBanners() {
  const [banners, setBanners] = useState<NewsBanner[]>([])
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(async () => {
    setLoading(true)
    try {
      const { list } = await lumi.entities.news_banners.list({
        sort: { createdAt: -1 },
        limit: 100,
      })
      setBanners((list as NewsBanner[]) || [])
    } catch (error) {
      console.error('Falha ao carregar banners de notícias:', error)
      setBanners([])
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return { banners, loading, refresh }
}
